import React, { useState, useEffect } from 'react';
import { Box, Container, Typography, Link, useTheme } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const Footer: React.FC = () => {
  const theme = useTheme();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(
    Boolean(localStorage.getItem('access_token'))
  );

  useEffect(() => {
    // Listen for authentication changes (e.g., login/logout).
    const handleAuthChange = () => {
      setIsAuthenticated(Boolean(localStorage.getItem('access_token')));
    };
    window.addEventListener('authChange', handleAuthChange);
    return () => {
      window.removeEventListener('authChange', handleAuthChange);
    };
  }, []);

  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 0,
        mt: 'auto',
        // Add padding at bottom to allow scrolling past the fixed nav
        pb: isAuthenticated ? 9 : 2,
        backgroundColor: (theme) =>
          theme.palette.mode === 'light'
            ? theme.palette.grey[200]
            : theme.palette.grey[800],
      }}
    >
      <Container maxWidth="md" sx={{ px: 0 }}>
        <Typography variant="body1" align="center">
          © {new Date().getFullYear()} Grocery Price Checker. All rights reserved.
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', mt: 1 }}>
          {isAuthenticated && (
            <Link
              component={RouterLink}
              to="/account"
              sx={{ mx: 1, color: theme.palette.text.primary }}
            >
              Account
            </Link>
          )}
          <Link
            component={RouterLink}
            to="/about"
            sx={{ mx: 1, color: theme.palette.text.primary }}
          >
            About
          </Link>
          <Link
            component={RouterLink}
            to="/contact"
            sx={{ mx: 1, color: theme.palette.text.primary }}
          >
            Contact Us
          </Link>
          <Link
            component={RouterLink}
            to="/privacy"
            sx={{ mx: 1, color: theme.palette.text.primary }}
          >
            Privacy
          </Link>
          <Link
            component={RouterLink}
            to="/terms"
            sx={{ mx: 1, color: theme.palette.text.primary }}
          >
            Terms
          </Link>
          <Link
            component={RouterLink}
            to="/cookies"
            sx={{ mx: 1, color: theme.palette.text.primary }}
          >
            Cookies
          </Link>
          <Link
            component={RouterLink}
            to="/attributions"
            sx={{ mx: 1, color: theme.palette.text.primary }}
          >
            Attributions
          </Link>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;